<template>
  <html>
    <head>
      <meta charset="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <link rel="icon" type="image/png" href="favicon.png" />
      <title>Restó APP</title>
    </head>
    <body>
      <header class="px-3 py-2 text-white" style="background: linear-gradient(79.95deg, #297C4B 42.76%, #4BE289 92.44%);">
        <div class="container text-center">
          <h1>CONTACTO</h1>
        </div>
      </header>
      <main class="container my-5">
        <div class="row justify-content-center">
          <div class="col-md-8 text-center">
            <p class="lead">Para cualquier consulta, por favor comuníquese con nosotros a través del siguiente correo electrónico:</p>
            <p class="h4"><a href="mailto:bandeja-manta@hotmail.com">bandeja-manta@hotmail.com</a></p>
          </div>
        </div>
      </main>
    </body>
  </html>
</template>

<script>
export default {
  name: "Contacto",
  components: {},
  data: function () {
    return {};
  },
  computed: {},
  methods: {},
  beforeMount() {},
};
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap");

body {
  font-family: 'Inter', sans-serif;
  background-color: #f8f9fa;
  margin: 0;
}

header h1 {
  margin: 0;
  padding: 20px 0;
}

main {
  padding: 40px 0;
}

main p.lead {
  font-size: 1.25rem;
  color: #333;
}

main p.h4 {
  font-size: 1.5rem;
  color: #297C4B;
}

main p.h4 a {
  text-decoration: none;
  color: inherit;
}

main p.h4 a:hover {
  text-decoration: underline;
}
</style>
